import React, { useMemo, useRef,} from 'react';
import './index.less';

const ProgressBar = (props: any) => {
  const { dataConfig } = props || {};
  const { progressBoxConfig, progressContentConfig, depth } = dataConfig || {};
  const progressBarRef = useRef<HTMLDivElement>(null); // 绑定到外层容器

  const progressBoxStyle = useMemo(() => {
    const { height, backgroundColor } = progressBoxConfig || {
      width: 12,
      height: 8,
      backgroundColor: '#ecebea',
    };
    return {
      // minWidth: depth === 1 ? '264px' : `${22.4}vw`,
      height: `${height}px`,
      backgroundColor,
    };
  }, [progressBoxConfig, depth]);

  const progressContentStyle = useMemo(() => {
    const { percent, node, backgroundColor, colorFilledProcess } = progressContentConfig || {
      percent: 0,
      height: 8,
      backgroundColor: '#107c10',
      colorFilledProcess: false,
    };
    const { hidePercent, value } = node || {};
    const positivePercent = colorFilledProcess
      ? 1
      : percent < 0
        ? Math.abs(percent)
        : percent;
    // 根据上面的逻辑positivePercent不可能小于0
    const computedWidth = positivePercent > 1  ? '100%' :  `${positivePercent * 100}%`;
    // 条形图需要按百分比指标展示长度
    const percentWidth = value < 0 ? '0%' : value > 1 ? '100%' : `${value * 100}%`;

    return {
      width: hidePercent ? percentWidth : computedWidth,
      height: `${progressBoxConfig?.height || 8}px`,
      backgroundColor,
    };
  }, [progressContentConfig, progressBoxConfig]);

  return (
    <div
      ref={progressBarRef}
      className="dbd-tree-box-progress-bar"
      style={{ ...progressBoxStyle }}
    >
      <div
        className="dbd-tree-box-progress-bar-content"
        style={{ ...progressContentStyle }}
      ></div>
    </div>
  );
};

export default ProgressBar;
